/* 
Componente decorativo para cuantificar el numero de puntos de un cliente de ilusiona
*/

import React from "react";

//CSS
import "./FlipCounter.css";

const GetDigits = (value) => {
  let positions = [0, 0, 0, 0, 0, 0];
  if (value) {
    let auxPositions = value
      .toString()
      .replace(/\B(?=(\d{1})+(?!\d))/g, ",")
      .split(",");
    auxPositions = auxPositions.reverse();
    auxPositions.forEach((value, index) => {
      positions[index] = parseInt(value);
    });
    positions = positions.reverse();
  }

  return positions;
};

const AnimatedCard = ({ animation, digit }) => {
  return (
    <div className={`flipCard ${animation}`}>
      <span>{digit}</span>
    </div>
  );
};

const StaticCard = ({ position, digit }) => {
  return (
    <div className={position}>
      <span>{digit}</span>
    </div>
  );
};

const FlipUnitContainer = ({ digit, shuffle }) => {
  // assign digit values
  let currentDigit = digit;
  let previousDigit = digit - 1;

  // to prevent a negative value
  previousDigit = previousDigit === -1 ? 9 : previousDigit;

  // shuffle digits
  const digit1 = shuffle ? previousDigit : currentDigit;
  const digit2 = !shuffle ? previousDigit : currentDigit;

  // shuffle animations
  const animation1 = shuffle ? "fold" : "unfold";
  const animation2 = !shuffle ? "fold" : "unfold";

  return (
    <div className={"flipUnitContainer"}>
      <StaticCard position={"upperCard"} digit={currentDigit} />
      <StaticCard position={"lowerCard"} digit={previousDigit} />
      <AnimatedCard digit={digit1} animation={animation1} />
      <AnimatedCard digit={digit2} animation={animation2} />
    </div>
  );
};

export default function FlipCounter({ since }) {
  const values = {
    counters: [
      { value: 0, shuffle: false },
      { value: 0, shuffle: false },
      { value: 0, shuffle: false },
      { value: 0, shuffle: false },
      { value: 0, shuffle: false },
      { value: 0, shuffle: false }
    ],
    digits: GetDigits(since)
  };

  const updateCounter = counter => {
    /* values.digits.forEach((digit, index) => {
        if (values.counters[index].value !== digit) {
          values.counters[index].shuffle = !values.counters[index].shuffle;
          values.counters[index].value = values.counters[index].value + 1;
        }
      }); */
    values.digits.forEach((digit, index) => {
      if (values.counters[index].value !== digit) {
        values.counters[index].shuffle = !values.counters[index].shuffle;
        values.counters[index].value = values.digits[index];
      }
    });
  };

  updateCounter();

  return (
    <div className={"flipClock"}>
      {values.counters.map((digit, index) => (
        <FlipUnitContainer
          key={index}
          digit={digit.value}
          shuffle={digit.shuffle}
        />
      ))}
    </div>
  );
}
